import { MagnifyingGlassIcon } from '@heroicons/react/24/outline';
import { PencilIcon, UserPlusIcon } from '@heroicons/react/24/solid';
import {
  Card,
  CardHeader,
  Input,
  Typography,
  Button,
  CardBody,
  Chip,
  Tabs,
  TabsHeader,
  Tab,
  Avatar,
  IconButton,
  Tooltip,
} from '@material-tailwind/react';
import { useSelector } from 'react-redux';
import { ModalCreateuser } from '../Modal/ModalCreateuser';
import { useState } from 'react';
import { ModalPassword } from '../Modal/ModalPassword';

const TABS = [
  {
    label: 'Todos',
    value: 'all',
  },
  {
    label: 'Ativo',
    value: true,
  },
  {
    label: 'Desativado',
    value: false,
  },
];

const TABLE_HEAD = ['Funcionario', 'Status', 'Ações'];

const classColor = 'text-black dark:text-darkText';

export function TableFuncionarios() {
  const [cadastro, setCadastro] = useState(false);
  const [edit, setEdit] = useState('');
  const [filterTab, setFilterTab] = useState('all');
  const [inputSearch, setInputSeacrh] = useState('');

  const handleModal = () => {
    setCadastro(false);
  };
  const handleEdit = () => {
    setEdit('');
  };

  const openEditModal = (value) => {
    const usuario = users.find((user) => user.id === value);
    setEdit(usuario);
  };
  const { theme, users } = useSelector((state) => state.auth);

  const dadosFiltrado = users.filter((user) => {
    const status = filterTab === 'all' ? true : user.is_active === filterTab;
    const search = inputSearch.toLocaleLowerCase();
    const filter = user.usuario.toLowerCase().includes(search);
    return status && filter;
  });

  return (
    <Card className="h-full w-full bg-transparent dark:bg-darkColorBox">
      <CardBody className="px-0 h-full">
        <div className="rounded-none bg-transparent px-4 py-2 pb-10">
          <div className="mb-8 flex items-center justify-between gap-8">
            <div>
              <Typography variant="h5" className={classColor}>
                Lista de Funcionarios
              </Typography>
              <Typography color="gray" className={`mt-1 font-normal ${classColor}`}>
                Veja informações sobre todos os membros
              </Typography>
            </div>
            <div className="flex shrink-0 flex-col gap-2 sm:flex-row">
              <Button
                className="flex items-center gap-3 dark:border"
                size="sm"
                onClick={() => setCadastro(true)}
              >
                <UserPlusIcon strokeWidth={2} className="h-4 w-4" /> Add funcionario
              </Button>
            </div>
          </div>
          <div className="flex flex-col items-center justify-between gap-4 md:flex-row">
            <Tabs value="all" className="w-full md:w-max">
              <TabsHeader>
                {TABS.map(({ label, value }) => (
                  <Tab key={value} value={value} onClick={() => setFilterTab(value)}>
                    &nbsp;&nbsp;{label}&nbsp;&nbsp;
                  </Tab>
                ))}
              </TabsHeader>
            </Tabs>
            <div className="w-full md:w-72">
              <Input
                color={theme ? 'white' : 'black'}
                label="Search"
                value={inputSearch}
                onChange={(e) => setInputSeacrh(e.target.value)}
                icon={<MagnifyingGlassIcon className="h-5 w-5 " />}
              />
            </div>
          </div>
        </div>
        <div className="overflow-scroll global-scrollbar p-0 mt-2 h-[600px]">
          <table className=" w-full min-w-max table-auto text-left dark:bg-darkTable">
            <thead className="sticky top-0 z-10 bg-darkMainColor">
              <tr>
                {TABLE_HEAD.map((head) => (
                  <th key={head} className="border-y border-blue-gray-100 dark:bg-darkTh p-4">
                    <Typography variant="h6" color="white" className="font-bold leading-none ">
                      {head}
                    </Typography>
                  </th>
                ))}
              </tr>
            </thead>
            <tbody className="dark:bg-darkRbgEstq">
              {dadosFiltrado.map(({ img, usuario, email, is_active, id }, index) => {
                const isLast = index === users?.length - 1;
                const classes = isLast ? 'p-4' : 'p-4 border-b border-blue-gray-50 ';

                return (
                  <tr key={usuario}>
                    <td className={classes}>
                      <div className="flex items-center gap-3">
                        <Avatar src="/img/bema2.png" alt={usuario} size="sm" />
                        <div className="flex flex-col">
                          <Typography
                            variant="small"
                            color="black"
                            className="font-normal   capitalize"
                          >
                            {usuario}
                          </Typography>
                          <Typography
                            variant="small"
                            color="black"
                            className="font-normal opacity-70  lowercase"
                          >
                            {email ? email : ''}
                          </Typography>
                        </div>
                      </div>
                    </td>

                    <td className={classes}>
                      <div className="w-max ">
                        <Chip
                          variant="filled"
                          size="sm"
                          value={is_active ? 'ativo' : 'desativado'}
                          color={is_active ? 'green' : 'blue-gray'}
                        />
                      </div>
                    </td>
                    <td className={classes}>
                      <Tooltip content="Edit User">
                        <IconButton variant="text" onClick={() => openEditModal(id)}>
                          <PencilIcon className="h-4 w-4 " color="black" />
                        </IconButton>
                      </Tooltip>
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
      </CardBody>
      {/* TODO fazer pagination se necessario */}
      {/* <CardFooter className="flex items-center justify-between border-t border-blue-gray-50 p-4">
        <Typography variant="small" color="black" className="font-normal dark:text-white">
          Page 1 of 10
        </Typography>
        <div className="flex gap-2">
          <Button variant="outlined" size="sm" className="dark:text-darkText dark:border-white">
            Previous
          </Button>
          <Button variant="outlined" size="sm" className="dark:text-darkText dark:border-white">
            Next
          </Button>
        </div>
      </CardFooter> */}
      <ModalCreateuser handleModal={handleModal} modal={cadastro} />
      <ModalPassword id={edit} handleModal={handleEdit} />
    </Card>
  );
}
